import { useSimpleListFilter } from "../../../../hooks/useListFilter";
import { noop } from "../../../forms";
import { SearchForm } from "../../../search/search";
import { Button, List, ListItem, Menu, MenuItem } from "@mui/material";
import { Close } from "@mui/icons-material";
import { T } from "../../../util/t";
import { useMenuState } from "../../../../hooks/useMenuState";
import { gql, useQuery } from "@apollo/client";

export const GET_SERIES_AVAILABLE_FILTERS = gql`
  query getSeriesAvailableFilters($id: ID!, $divisionId: ID!) {
    series(id: $id) {
      id
      availableRankingFilters(divisionId: $divisionId)
    }
  }
`;
export const RankingsFilterButton = ({ seriesId, divisionId, label, filter, setFilter }) => {
    const [anchorEl, openMenu, closeMenu] = useMenuState();
    const { data } = useQuery(GET_SERIES_AVAILABLE_FILTERS, {
            variables: { id: seriesId, divisionId: divisionId },
            fetchPolicy: "cache-and-network",
            nextFetchPolicy: "cache-first"
        }),
        options = data?.series.availableRankingFilters;
    const clearFilter = e => {
        e.stopPropagation();
        setFilter();
    };

    return (
        <>
            <Button variant="outlined" onClick={openMenu} className={(!!filter || !!anchorEl) ? "Mui-selected" : ""} disabled={!options?.length}>
                {filter ?
                    <>{filter}<Close fontSize="small" onClick={clearFilter} sx={{ ml: 1 }} aria-label="clear"/></> :
                    <T label={label}>property_filter_label_all_values</T>
                }
            </Button>
            <Menu open={!!anchorEl} onClose={closeMenu} anchorEl={anchorEl} slotProps={{ paper: { style: { maxHeight: 400 }  } }}>
                <RankingsFilterMenu options={options} setFilter={setFilter} closeMenu={closeMenu}/>
            </Menu>
        </>
    );
};

export const RankingsFilterMenu = ({ options, setFilter, closeMenu }) => {
    const { searchString, onSearch, filteredList } = useSimpleListFilter(options, noop);
    const selectItem = item => {
        setFilter(item);
        closeMenu();
    };

    return (
        <List>
            <ListItem>
                <SearchForm search={searchString} onChange={onSearch} placeholder="Search"/>
            </ListItem>
            {filteredList.map(option => <MenuItem key={option} onClick={() => selectItem(option)}>{option}</MenuItem>)}
        </List>
    );
};
